export const MV_MOVIE = {
  init: function () {
    const $v = $('#load_movie')
    if (!$v.length) {
      return
    }

    // HTML の data 属性からパスを取得
    const sp = $v.data('sp')
    const pc = $v.data('pc')
    const spPoster = $v.data('sp-poster')
    const pcPoster = $v.data('pc-poster')
    let windowWidth = parseInt(document.body.clientWidth)
    const replaceWidth = 768
    let timer = false

    function videoSwitch() {
      // ウィンドウサイズに応じて動画切り替え
      if (windowWidth >= replaceWidth) {
        $v.attr('src', pc)
        $v.attr('poster', pcPoster)
      } else {
        $v.attr('src', sp)
        $v.attr('poster', spPoster)
      }

      // 動画再生
      $v.get(0).muted = true // mutedが必要
      $v.get(0)
        .play()
        .catch(error => {
          console.error('動画の再生に失敗しました:', error)
        })
    }

    // 初期化時に切り替え
    videoSwitch()

    // ウィンドウサイズ変更時に切り替え
    $(window).on('orientationchange resize', function () {
      const resizeWidth = parseInt(document.body.clientWidth)
      if (windowWidth !== resizeWidth) {
        if (timer !== false) clearTimeout(timer)
        timer = setTimeout(function () {
          videoSwitch()
          windowWidth = resizeWidth
        }, 200)
      }
    })
  },
}

// <div class="p-top-hero__img">
//   <video
//     id="load_movie"
//     autoplay
//     loop
//     muted
//     playsinline
//     poster="<?= get_template_directory_uri(); ?>/assets/img/top/mv_poster_pc.png"
//     src="<?= get_template_directory_uri(); ?>/assets/img/top/hero_im01.mp4"
//     data-sp="<?= get_template_directory_uri(); ?>/assets/img/top/hero_im01_sp.mp4"
//     data-pc="<?= get_template_directory_uri(); ?>/assets/img/top/hero_im01.mp4"
//     data-sp-poster="<?= get_template_directory_uri(); ?>/assets/img/top/mv_poster_sp.png"
//     data-pc-poster="<?= get_template_directory_uri(); ?>/assets/img/top/mv_poster_pc.png"
//     type="video/mp4"
//   ></video>
// </div>
